import { useState } from "react"; 
import { jwtFetch } from "./utils/apiClient";
import { useNavigate } from 'react-router-dom';
import { config } from "./Components/Config";
import Menu from "./Components/Menu";
import Header from "./Components/Header";

const CategoryAdd = () => {
  const [ productCategoryName, setProductCategoryName ] = useState('');
  const [ productCategoryTerms, setProductCategoryTerms ] = useState('');
  const [ productCategoryStatus, setProductCategoryStatus ] = useState('Active');
  const [ isLoadingSubmit, setIsLoadingSubmit ] = useState(false);

  const navigate = useNavigate();

  const submitCategoryAdd = async (e) => {
    try {
      e.preventDefault();
      setIsLoadingSubmit(true);
      const requestCategoryAdd = {
        "product_category_name": productCategoryName,
        "product_category_terms": productCategoryTerms,
        "product_category_status": productCategoryStatus,
      }
      const fetchCategoryAdd = await jwtFetch(config.ENDPOINT + 'create/product_category', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestCategoryAdd)
      });
      const responseCategoryAdd = await fetchCategoryAdd.json();
      if (responseCategoryAdd.status === 200) {
        window.location.href = '/product/category';
      } else {
        alert(responseCategoryAdd.message);
        setIsLoadingSubmit(false);
      }
    } catch (error) {
      console.error('Error in submitCategoryAdd:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoadingSubmit(false);
    }
  }

  return (
    <div id="category-add">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar"/></a>
            </div>
            <hr className="m-0"/>
            <Menu active="product"/>
          </div>
          <div className="col-md-10">
            <Header/>
            <hr className="m-0"/>
            <div className="main">
              <div className="p-4">

                <section className="mb-4">
                  <div className="fs-24 mb-3"><button className="btn btn-link" onClick={() => navigate(-1)}><i className="bi bi-arrow-left"/></button> Category Add</div>
                  <form className="row" onSubmit={(e) => submitCategoryAdd(e)}>
                    <div className="col-md-6">
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Name <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <input className="form-control" type="text" value={productCategoryName} onChange={(e) => setProductCategoryName(e.target.value)} required autoFocus/>
                        </div>
                      </div>
                      <div className="row form-group align-items-baseline mb-2">
                        <div className="col-md-4">
                          <label>Subscription Terms</label>
                        </div>
                        <div className="col-md-8">
                          <textarea className="form-control" rows="5" value={productCategoryTerms} onChange={(e) => setProductCategoryTerms(e.target.value)}/>
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Status <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <div className="form-check form-switch pt-1">
                            <input className="form-check-input" id="category-active" type="checkbox" value="Active" onChange={() => setProductCategoryStatus(productCategoryStatus === 'Active' ? 'Inactive' : 'Active')} checked={productCategoryStatus === 'Active' ? true : false}/>
                            <label className="form-check-label" htmlFor="category-active">{productCategoryStatus}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="d-flex justify-content-end mb-4">
                        <button className="btn btn-sm btn-link text-danger" type="button" onClick={() => window.location.href = '/product/category'}>Cancel</button>
                        <button className="btn btn-sm btn-primary ms-2" type="submit" disabled={isLoadingSubmit}>{isLoadingSubmit ? 'Loading...' : 'Save'}</button>
                      </div>
                    </div>
                  </form>
                </section>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryAdd;


